/* eslint-disable react/jsx-no-bind */
import React, { Component, PropTypes } from 'react';
import Glyph, { VOLUME_MEDIUM } from 'es6/components/common/glyph';
import SoundManager from 'es6/services/sound-manager';
import classnames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import { optionalOneOf } from 'es6/helpers/prop-types';

import {
  SOUND_PLAYER_SENTENCE_COLOR,
  SOUND_PLAYER_SENTENCE_HOVER_COLOR,
} from 'es6/core/styles/colors';

// variants
export const SOUND_PLAYER_SENTENCE = 'sentence';
export const SOUND_PLAYER_UNSTYLED = 'unstyled';

/**
 * @this SoundPlayer
 */
function playSound() {
  this.setState({ playing: true });

  SoundManager.play(this.props.source, {
    finished: () => {
      this.setState({ playing: false }, this.props.onFinish);
    },
  });
}

export default class SoundPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = { playing: false };
  }

  render() {
    const { playing } = this.state;
    const className = classnames(
      'sound-player',
      this.props.className,
      css(styles[this.props.variant]),
      {
        playing,
        sound: this.props.variant !== SOUND_PLAYER_UNSTYLED,
      }
    );

    return (
      <Glyph type={VOLUME_MEDIUM} className={className} onClick={playSound.bind(this)} />
    );
  }
}

SoundPlayer.propTypes = {
  className: PropTypes.string,
  variant: optionalOneOf([SOUND_PLAYER_SENTENCE, SOUND_PLAYER_UNSTYLED]),
  source: PropTypes.string.isRequired,
  onFinish: PropTypes.func,
};

const styles = StyleSheet.create({
  sentence: {
    fontSize: '16px',
    cursor: 'pointer',
    color: SOUND_PLAYER_SENTENCE_COLOR,
    display: 'inline-block',
    border: 0,
    padding: 0,
    margin: 0,
    background: 'transparent',
    ':hover':  { color: SOUND_PLAYER_SENTENCE_HOVER_COLOR },
    ':active': { color: SOUND_PLAYER_SENTENCE_HOVER_COLOR },
  },
});
